// extracted by mini-css-extract-plugin
export default {"LostPasswordView":"LostPasswordView_LostPasswordView__e+Ktr"};